import React from 'react';
import './RushPage.scss';
import Reveal from '../Reveal/Reveal';
// Import hero background image
import rushpagetop from '../../images/BackgroundImages/recruitment2.jpeg';

// ---------------------------------------------------------------------------
// SEASONAL POSTER + COPY — update these two values each recruitment cycle.
// ---------------------------------------------------------------------------
import fallrec from '../../images/BackgroundImages/Fall2026TTRecruitment.jpeg';
const RECRUITMENT_SEASON = 'Fall 2026';
const RECRUITMENT_COPY = `Welcome to Theta Tau, the foremost professional coed fraternity in San Luis Obispo!
Our recruitment process is designed to provide both prospective members and our
current members the opportunity to get to know each other better. Throughout
the week-long journey, attendees will engage in various events and activities
where they can learn about our three pillars and about the organization we've
built. Whether it's attending workshops, social gatherings, or professional
networking sessions, prospective members are encouraged to attend as many days
as they can. Our recruitment process is completely free, and at the end of the
week, we extend bids to those individuals who exemplify the qualities we seek
in Theta Tau members. It's then up to them to decide if they want to begin our
exciting new member process. Come join us and discover if Theta Tau is the
perfect fit for you!`;
const RUSH_FORM_URL = 'https://forms.gle/cgvXNshaqxCNC8ns8';
const RUSH_LINKTREE_URL = 'https://linktr.ee/ThetaTauSLO?utm_source=linktree_profile_share&ltsid=d49766f4-07d2-4d6f-bfd3-42f90688cd38';

// ---------------------------------------------------------------------------
// SCHEDULE — transcribed verbatim from the poster art (Fall2026TTRecruitment.jpeg).
// Update this array each recruitment cycle instead of editing the poster copy
// below; each row drives one entry in the accessible, real-text schedule list.
// ---------------------------------------------------------------------------
const RECRUITMENT_SCHEDULE = [
    { day: 'Monday 8/31', event: 'Info Night', details: 'Baker 180 rm 102 · 8:15pm' },
    { day: 'Tuesday 9/1', event: 'Brotherhood Night', details: 'Baker 180 rm 114 · 8:15pm' },
    { day: 'Wednesday 9/2', event: 'Service Night', details: 'Baker 180 rm 102 · 8:15pm' },
    { day: 'Thursday 9/3', event: 'Profession Night', details: 'Baker 180 rm 102 · 8:15pm' },
    { day: 'Friday 9/4', event: 'BBQ Night', details: 'Invite Only' },
];
// ---------------------------------------------------------------------------

// Recruitment/Rush page component.
// Leads with the current-season poster: a title on paper, a clean hero
// photograph plate, then the poster plate alongside the recruitment copy.
function RushPage() {
    const copyParagraphs = RECRUITMENT_COPY.split('\n\n');

    return (
    <div className="rush-page">
        <header className="rush-hero">
            <Reveal as="h1" variant="mask" className="rush-hero-title">
                <span className="rush-hero-title-season">{RECRUITMENT_SEASON}</span>
                <span className="rush-hero-title-word">Recruitment</span>
            </Reveal>
        </header>
        {/* Hero photograph as a clean, generous plate — no scrim, no text overlay */}
        <Reveal as="div" variant="plate" className="rush-hero-plate">
            <img src={rushpagetop} alt="Rush Poster" className="rush-hero-photo"/>
        </Reveal>

        {/* Poster + recruitment details */}
        <section className="rush-cover" aria-labelledby="rush-cover-heading">
            <Reveal as="div" variant="plate" index={1} className="rush-poster-plate">
                <img src={fallrec} alt={`${RECRUITMENT_SEASON} Recruitment`} className="rush-poster"/>
            </Reveal>
            <div className="rush-details">
                <Reveal as="h2" id="rush-cover-heading" variant="mask">{RECRUITMENT_SEASON} Recruitment</Reveal>
                {copyParagraphs.map((paragraph, idx) => (
                    <Reveal as="p" variant="rise" index={idx + 1} className="rush-copy" key={idx}>{paragraph.replace(/\n/g, ' ')}</Reveal>
                ))}
                <Reveal as="p" variant="rise" index={copyParagraphs.length + 1} className="rush-copy rush-copy--note">
                    Fill out this <a href={RUSH_FORM_URL} target="_blank" rel="noreferrer">form</a> to receive updates on when our recruitment process begins! You can also visit our <a href={RUSH_LINKTREE_URL} target="_blank" rel="noreferrer">linktree</a> for more information.
                </Reveal>
                <Reveal as="div" variant="rise" index={copyParagraphs.length + 2} className="rush-cta-actions">
                    <a
                        className="btn btn--filled"
                        href={RUSH_FORM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Fill out the Theta Tau recruitment interest form (opens in a new tab)"
                    >
                        Interest Form
                    </a>
                    <a
                        className="btn btn--outline"
                        href={RUSH_LINKTREE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Visit the Theta Tau SLO linktree (opens in a new tab)"
                    >
                        Linktree
                    </a>
                </Reveal>
            </div>
        </section>

        {/* Recruitment schedule, transcribed from the poster so it is
            selectable and screen-reader accessible; poster stays alongside
            as supporting art. */}
        <section className="rush-schedule" aria-labelledby="rush-schedule-heading">
            <Reveal as="h2" id="rush-schedule-heading" variant="mask" className="rush-schedule-heading">
                {RECRUITMENT_SEASON} Schedule
            </Reveal>
            <dl className="rush-schedule-list">
                {RECRUITMENT_SCHEDULE.map((item, idx) => (
                    <Reveal as="div" variant="rise" index={idx} className="rush-schedule-item" key={item.event}>
                        <dt className="rush-schedule-day">{item.day}</dt>
                        <dd className="rush-schedule-event">{item.event}</dd>
                        <dd className="rush-schedule-details">{item.details}</dd>
                    </Reveal>
                ))}
            </dl>
            <p className="rush-schedule-contact">
                Questions? Email <a href="mailto:camanzan@calpoly.edu">camanzan@calpoly.edu</a> or{' '}
                <a href="mailto:nkaldas@calpoly.edu">nkaldas@calpoly.edu</a>, or find us on Instagram{' '}
                <a href={RUSH_LINKTREE_URL} target="_blank" rel="noopener noreferrer">@THETATAUSLO</a>.
            </p>
        </section>
    </div>
    );
}

export default RushPage;
